// ============================================================================
// Table Columns: CustomProperties
// Key: customProperties
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	enumRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type {
	CustomPropertyDto,
	CustomPropertyRuleSetDto,
	CustomPropertySummary,
	RuleSetSummary,
} from '../api/backstage.schemas'
import { CustomPropertyLinkRuleType } from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const customPropertiesListColumnsConfig = {
	columns: [
		'key',
		'keyDisplayName',
		cellRenderer('sortOrder', 'number'),
		cellRenderer('hidden', 'boolean'),
		cellRenderer('ruleSetsCount', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: CustomPropertySummary) =>
				`/customProperties/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<CustomPropertySummary>
// #endregion

// #region Relation List Columns
// #region Relation: RuleSets
export const customPropertiesRelationsRuleSetsAssignedColumnsConfig = {
	columns: ['ruleSetName', 'ruleSetDescription', 'customPropertyName'],
} as const satisfies EntityTableConfig<CustomPropertyRuleSetDto>
export const customPropertiesRelationsRuleSetsAvailableColumnsConfig = {
	columns: [
		'name',
		'description',
		cellRenderer('color', 'color'),
		cellRenderer('tabColor', 'color'),
		cellRenderer('contactColor', 'color'),
		cellRenderer('italic', 'boolean'),
		cellRenderer('bold', 'boolean'),
		cellRenderer('underline', 'boolean'),
		cellRenderer('isHidden', 'boolean'),
		'replaceValue',
		enumRenderer(
			'link',
			CustomPropertyLinkRuleType,
			'CustomPropertyLinkRuleType',
		),
		'linkDisplayName',
		cellRenderer('openContactDetailBeforeAccepting', 'boolean'),
		cellRenderer('hideValue', 'boolean'),
		cellRenderer('showInSplit', 'boolean'),
		'maxWidth',
		'minWidth',
		cellRenderer('customPropertyCount', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
} as const satisfies EntityTableConfig<RuleSetSummary>
// #endregion
// #endregion

// #region Client List Columns
export const customPropertiesClientGetColumnsConfig = {
	columns: [
		'key',
		'keyDisplayName',
		cellRenderer('sortOrder', 'number'),
		cellRenderer('hidden', 'boolean'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		'ruleSets',
	],
} as const satisfies EntityTableConfig<CustomPropertyDto>
// #endregion

// #region Columns Config Export
export const customPropertiesColumnsConfig = {
	list: customPropertiesListColumnsConfig,
	relations: {
		ruleSets: {
			assigned: customPropertiesRelationsRuleSetsAssignedColumnsConfig,
			available: customPropertiesRelationsRuleSetsAvailableColumnsConfig,
		},
	},
	client: {
		get: customPropertiesClientGetColumnsConfig,
	},
} as const
// #endregion
